// This file is temporary solution until Rudderstack team will release
// default connection between cookie categories and cloud mode integrations

declare global {
  // eslint-disable-next-line no-var
  var OnetrustActiveGroups: undefined | string;
}

export enum OneTrustCategoryIds {
  strictlyNecessary = 'C0001',
  performance = 'C0002',
  functional = 'C0003',
  targeting = 'C0004',
  socialMedia = 'C0005',
}

export const getActiveCategories = () => {
  if (typeof window === 'undefined' || !window?.OnetrustActiveGroups) {
    return [];
  }

  return window.OnetrustActiveGroups.split(',').filter(
    Boolean,
  ) as OneTrustCategoryIds[];
};

export const BASIC_ACTIVE_CATEGORIES_NUMBER = [
  OneTrustCategoryIds.strictlyNecessary,
].length;
